module.exports = __webpack_public_path__ + "static/media/jonas.d7044123.jpg";